import desktopLogos from '@/static/assets/pet/over-45-desktop-logos.svg';
import { Box, Flex } from '@lemonade-hq/cdk';
import Script from 'next/script';
import type React from 'react';
import { useState } from 'react';
import { LogosWrapper, ScrollArrow, ScrollArrowContainer, TrustpilotContainer } from './PetOver45/Over45Hero/styles';

interface TruspilotSectionProps {
  children: React.ReactNode;
}

export const TruspilotSection: React.FC<TruspilotSectionProps> = ({ children }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <Script
        type="text/javascript"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
        onLoad={() => {
          setShow(true);
        }}
      />
      <Flex mt={[60, 'auto']} flexDirection="column" alignItems="center">
        <TrustpilotContainer showTrustpilot={show}>{children}</TrustpilotContainer>

        <Box display={['none', 'block']}>
          <LogosWrapper src={desktopLogos} alt="Pet insurance logos" />
        </Box>

        <ScrollArrowContainer>
          <ScrollArrow />
        </ScrollArrowContainer>
      </Flex>
    </>
  );
};
